export enum TransactionChannel {
  Cardholder_Present = 'cardholder_present',
  Ecommerce = 'ecommerce',
  Moto = 'moto',
  Recurring = 'recurring',
  Unknown = 'unknown'
}
